import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { ModeToggle } from './mode-toggle';
import { useTranslation } from 'react-i18next';

export const Footer = ({ landingMode = false }: { landingMode?: boolean } = {}) => {
  const { i18n, t } = useTranslation('common');
  const currentLang = i18n.language;

  const links = [
    {
      name: currentLang === 'de' ? 'Über uns' : 'About',
      href: '/about',
    },
    {
      name: currentLang === 'de' ? 'Karriere' : 'Careers',
      href: '/careers',
    },
    {
      name: currentLang === 'de' ? 'Kontakt' : 'Contact',
      href: '/contact',
    },
  ];
  const legal = [
    {
      name: currentLang === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy',
      href: '/privacy',
    },
    {
      name: currentLang === 'de' ? 'Geschäftsbedingungen' : 'Terms of Service',
      href: '/terms',
    },
    {
      name: currentLang === 'de' ? 'Impressum' : 'Legal Notice',
      href: '/legal-disclosure',
    },
  ];
  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('verdea:open-cookie-settings'));
  };

  const socials = [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/verdea-app//',
    },
    {
      name: 'GitHub',
      href: 'https://github.com/verdea-app',
    },
    {
      name: 'Twitter',
      href: 'https://x.com/VerdeaApp',
    },
  ];
  return (
    <div className="relative">
      <div className="border-b-2 border-t-2 border-neutral-100 dark:border-neutral-800 px-8 pt-20 pb-32 relative bg-background dark:bg-transparent">
        <div className="max-w-7xl mx-auto text-sm text-neutral-500 dark:text-neutral-400 flex sm:flex-row flex-col justify-between items-start ">
          <div>
            <div className="mr-4 md:flex mb-4">
              <Logo />
            </div>
            {!landingMode && (
              <div className="flex items-center gap-2 mb-3">
                <div className="text-foreground dark:text-neutral-400">
                  {currentLang === 'de' ? 'Design:' : 'Theme:'}
                </div>
                <ModeToggle />
              </div>
            )}
            <div className="text-foreground dark:text-neutral-400">
              Copyright &copy; 2026 Verdea
            </div>
            <div className="mt-2 text-foreground dark:text-neutral-400">
              {currentLang === 'de' ? 'Alle Rechte vorbehalten' : 'All rights reserved'}
            </div>
          </div>
          <div
            className={`${landingMode ? 'grid-cols-1' : 'grid-cols-2'} grid gap-10 items-start mt-10 md:mt-0`}
          >
            {!landingMode && (
              <div className="flex justify-center space-y-4 flex-col mt-4">
                {links.map(link => (
                  <Link
                    key={link.name}
                    className="transition-all hover:text-foreground hover:underline hover:scale-105 text-muted dark:text-muted-dark dark:hover:text-white text-xs sm:text-sm py-1 px-1 -mx-1 rounded hover:bg-neutral-50 dark:hover:bg-neutral-800"
                    to={link.href}
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            )}
            <div className="flex justify-center space-y-4 flex-col mt-4">
              {legal.map(link => (
                <Link
                  key={link.name}
                  className="transition-all hover:text-foreground hover:underline hover:scale-105 text-muted dark:text-muted-dark dark:hover:text-white text-xs sm:text-sm py-1 px-1 -mx-1 rounded hover:bg-neutral-50 dark:hover:bg-neutral-800"
                  to={link.href}
                >
                  {link.name}
                </Link>
              ))}
              <button
                onClick={openCookieSettings}
                className="text-left transition-all hover:text-foreground hover:underline hover:scale-105 text-muted dark:text-muted-dark dark:hover:text-white text-xs sm:text-sm py-1 px-1 -mx-1 rounded hover:bg-neutral-50 dark:hover:bg-neutral-800"
              >
                {t('cookie.settings')}
              </button>
            </div>
            {/*<div className="flex justify-center space-y-4 flex-col mt-4 ">*/}
            {/*  {socials.map((link) => (*/}
            {/*    <a*/}
            {/*      key={link.name}*/}
            {/*      className="transition-all hover:text-foreground hover:underline hover:scale-105 text-muted dark:text-muted-dark dark:hover:text-white text-xs sm:text-sm py-1 px-1 -mx-1 rounded hover:bg-neutral-50 dark:hover:bg-neutral-800"*/}
            {/*      href={link.href}*/}
            {/*      target="_blank"*/}
            {/*      rel="noopener noreferrer"*/}
            {/*    >*/}
            {/*      {link.name}*/}
            {/*    </a>*/}
            {/*  ))}*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
      <div className="relative overflow-hidden mx-auto max-w-[100vw] lg:max-w-[100vw]">
        {/* Main text with shine effect */}
        <p className="text-center text-7xl md:text-9xl lg:text-[18rem] xl:text-[24rem] font-bold bg-clip-text text-transparent bg-gradient-to-b from-white to-neutral-200 dark:from-neutral-600  dark:to-neutral-800 relative z-10 py-3">
          VERDEA
        </p>
      </div>
    </div>
  );
};
